<template>
  <v-container class="fill-height">
    <v-row class="text-center">
      <v-col cols="12">
        Redirecting...
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import homeMixin from '../mixins/home.mixin';

export default {
  name: "Home",

  mixins: [homeMixin]
}
</script>
